:host {
  display: block;
}
:host .table {
  display: table;
  background-color: var(--color-background);
  font-family: var(--font-family-primary);
  font-size: 8.5px;
}
:host .tr {
  display: table-row;
  cursor: pointer;
}
:host .tr:hover {
  background-color: var(--color-secondary-enabled);
}
:host .tr.selected {
  background-color: var(--color-secondary-active);
}
:host .tbody {
  display: table-row-group;
}
:host .td,
:host .th {
  display: table-cell;
}
:host .th:hover {
  background-color: var(--gray-03);
}
:host .td {
  padding: 5px 8px;
  border-bottom: 1px solid var(--color-on-disabled);
  border-left: 1px solid var(--color-on-disabled);
  border-right: 1px solid var(--color-on-disabled);
  color: var(--color-on-background);
}
:host .th {
  padding: 10px var(--spacing-comp-02);
  text-transform: uppercase;
  font-weight: bold;
  background-color: var(--gray-02);
  color: var(--color-on-background);
  letter-spacing: var(--letter-spacing-sm);
}
:host .icon-text-container {
  position: relative;
  padding-left: 12px;
}
:host .icon-text-container gxg-icon {
  position: absolute;
  left: -6px;
  top: -4px;
  cursor: pointer;
}